import { render } from "./MMAdminMemberFiles.vue?vue&type=template&id=36010bb3"
import script from "./MMAdminMemberFiles.vue?vue&type=script&lang=js"
export * from "./MMAdminMemberFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__